module.exports = __webpack_public_path__ + "static/media/minus.2311db12.svg";